import { Col, Row, Label, CardBody } from 'reactstrap';
import { api } from '../../../config';
import { useState, useEffect } from 'react';
import { SkeletonTable } from '../../../Components/Common/Skeleton';

const ModeDeliveryTableFragment = ({
  procurementId,
  quantityDeliveryTermId,
  token,
}) => {
  const [qtyModeDeliveryIncoterm, setQtyModeDeliveryIncoterm] = useState({
    items: [],
  });
  const [loaded, setLoaded] = useState(false);

  const [currentPage] = useState(1);
  const [rowsPerPage] = useState(30);

  useEffect(() => {
    fetchDeliveryDataDetailIncoterm(
      procurementId,
      quantityDeliveryTermId,
      currentPage,
      rowsPerPage,
      token
    );
  }, [procurementId, quantityDeliveryTermId, currentPage, rowsPerPage, token]);

  const fetchDeliveryDataDetailIncoterm = async (
    procurementId,
    quantityDeliveryTermId,
    currentPage,
    rowsPerPage,
    token
  ) => {
    try {
      const response = await fetch(
        `${api.API_URL}/procurement/get-delivery-detail?PageNumber=${currentPage}&PageSize=${rowsPerPage}&procurementId=${procurementId}&quantityDeliveryTermId=${quantityDeliveryTermId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.data.flatMap(item =>
        item.listData.map(details => ({
          id: item.id,
          quantityInformationId: details?.quantityInformationId ?? null,
          quantityIncotermId: details.quantityIncotermId ?? null,
          quantityLocation2: details.quantityLocation2 ?? null,
          dyed: details.dyed ?? null,
          undyed: details.undyed ?? null,
          dyed2: details.dyed2 ?? null,
          undyed2: details.undyed2 ?? null,
          deliveryBasis: details.deliveryBasis ?? null,
          incoterm: details.incoterm ?? null,
          route: details.route ?? null,
          loadingPort: details.loadingPort ?? null,
          parcelSize: details.parcelSize ?? null,
          port1: details.port1 ?? null,
          addAld: details.addAld ?? null,
          alpha1: details.alpha1 ?? 0,
          parcelSize2: details.parcelSize2 ?? null,
          port2: details.port2 ?? null,
          addAld2: details.addAld2 ?? null,
          alpha2: details.alpha2 ?? null,
        }))
      );
      setQtyModeDeliveryIncoterm({ items });
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setLoaded(true);
    }
  };

  return (
    <Col lg={12}>
      <Row>
        <Col sm={12}>
          <div className='mb-2 mt-3'>
            <Label for='product-name-1' className='form-label fw-semibold'>
              Incoterm
            </Label>
            <CardBody>
              <div className='table-card overflow-x-auto'>
                <table className='table table-hover table-centered align-middle table-nowrap '>
                  <thead className='table-light'>
                    <tr>
                      <th scope='col' width='7%'>
                        Parcel Size
                      </th>
                      <th scope='col' width='7%'>
                        Incoterm
                      </th>
                      <th scope='col' width='8%'>
                        Route
                      </th>
                      <th scope='col' width='10%'>
                        Loading Port
                      </th>
                      <th scope='col' width='8%'>
                        Dicharged Qty 1
                      </th>
                      <th scope='col' width='10%'>
                        Port 1
                      </th>
                      <th scope='col' width='10%'>
                        ALD/ADD
                      </th>
                      <th scope='col' width='6%'>
                        Alpha
                      </th>
                      <th scope='col' width='8%'>
                        Dicharged Qty 2
                      </th>
                      <th scope='col' width='10%'>
                        Port 2
                      </th>
                      <th scope='col' width='10%'>
                        ALD / ADD
                      </th>
                      <th scope='col' width='6%'>
                        Alpha
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loaded && <SkeletonTable inline rows={2} columns={12} />}
                    {qtyModeDeliveryIncoterm.items.map((data, index) => (
                      <tr key={`${data.id}-${index}`}>
                        <td>{data.deliveryBasis}</td>
                        <td>{data.incoterm}</td>
                        <td>{data.route}</td>
                        <td>{data.loadingPort}</td>
                        <td>{data.parcelSize}</td>
                        <td>{data.port1}</td>
                        <td>{data.addAld}</td>
                        <td></td>
                        <td>{data.parcelSize2}</td>
                        <td>{data.port2}</td>
                        <td>{data.addAld2}</td>
                        <td></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default ModeDeliveryTableFragment;
